<div #slider class="ant-slider" [class.ant-slider-rtl]="dir === 'rtl'" [class.ant-slider-disabled]="nzDisabled" [class.ant-slider-vertical]="nzVertical" [class.ant-slider-with-marks]="marksArray">
  <div class="ant-slider-rail"></div>
  <ui-slider-track [uiVertical]="nzVertical" [uiIncluded]="nzIncluded" [uiOffset]="track.offset!" [uiLength]="track.length!" [uiReverse]="nzReverse" [uiDir]="dir"></ui-slider-track>
  <ui-slider-step
    *ngIf="marksArray"
    [uiVertical]="nzVertical"
    [uiMin]="nzMin"
    [uiMax]="nzMax"
    [uiLowerBound]="$any(bounds.lower)"
    [uiUpperBound]="$any(bounds.upper)"
    [uiMarksArray]="marksArray"
    [uiIncluded]="nzIncluded"
    [uiReverse]="nzReverse"></ui-slider-step>
  <ui-slider-handle
    *ngFor="let handle of handles; index as handleIndex"
    [uiVertical]="nzVertical"
    [uiReverse]="nzReverse"
    [uiOffset]="handle.offset!"
    [uiValue]="handle.value!"
    [uiActive]="handle.active"
    [uiTooltipFormatter]="nzTipFormatter"
    [uiTooltipVisible]="nzTooltipVisible"
    [uiTooltipPlacement]="nzTooltipPlacement"
    [uiDir]="dir"
    (focusin)="onHandleFocusIn(handleIndex)"></ui-slider-handle>
  <ui-slider-marks
    *ngIf="marksArray"
    [uiVertical]="nzVertical"
    [uiMin]="nzMin"
    [uiMax]="nzMax"
    [uiLowerBound]="$any(bounds.lower)"
    [uiUpperBound]="$any(bounds.upper)"
    [uiMarksArray]="marksArray"
    [uiIncluded]="nzIncluded"
    [uiReverse]="nzReverse"></ui-slider-marks>
</div>
